export default function PeopleIcon({ className }: { className?: string }) {
    return (
        <svg
            className={className}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            {/* back person */}
            <path
                data-people-part="back"
                d="M18.8098 7.7277C18.8098 9.2343 17.5886 10.4554 16.082 10.4554C14.5754 10.4554 13.3543 9.2343 13.3543 7.7277C13.3543 6.2211 14.5754 5 16.082 5C17.5886 5 18.8098 6.2211 18.8098 7.7277ZM17.7056 11.0608H14.4585C13.2305 11.0608 12.1676 11.7831 11.6792 12.8254C13.2512 13.1074 14.5273 14.2563 14.9951 15.7595H19.8589C20.3679 15.7595 20.7807 15.3467 20.7807 14.8376V14.1325C20.7773 12.4367 19.4014 11.0608 17.7056 11.0608Z"
                fill="#B1AEC7"
            />
            {/* front person */}
            <path
                data-people-part="front"
                d="M8.93815 5.85352C7.09789 5.85352 5.60505 7.34636 5.60505 9.18661C5.60505 11.0269 7.09789 12.5197 8.93815 12.5197C10.7784 12.5197 12.2712 11.0269 12.2712 9.18661C12.2712 7.34636 10.7818 5.85352 8.93815 5.85352ZM14.6791 17.8719V17.0154C14.6791 14.9413 12.997 13.2592 10.9229 13.2592H6.95686C4.88271 13.2592 3.20068 14.9413 3.20068 17.0154V17.8719C3.20068 18.4945 3.70632 19.0001 4.32891 19.0001H13.5577C14.1769 19.0001 14.6791 18.4945 14.6791 17.8719Z"
                fill="#64617E"
            />
        </svg>
    )
}
